import {
  FETCH_ALL_EDI_ORDER_ITEMS,
  UPDATE_EDI_ORDER_ITEM,
} from './../../mutation-types';

export default {
  [FETCH_ALL_EDI_ORDER_ITEMS](state, ediOrderItems) {
    state.all = ediOrderItems;
  },

  [UPDATE_EDI_ORDER_ITEM](state, { ediOrderItem, id }) {
    state.all.map((p) => {
      if (p.id === id) {
        Object.keys(ediOrderItem).map((k) => {
          p[k] = ediOrderItem[k];
          return k;
        });
      }
      return p;
    });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/ediOrderItem/mutations.js